import {defineStore} from "pinia";
import {ref} from "vue";
import {useFetch} from "@vueuse/core";
import {BASE_URI} from "@/assets/const";

// import VueCookies from 'vue-cookies'



export const сollegesListStore = defineStore('сollegesListStore', () => {

    const isPending = ref(false)
    const сollegesList = ref()
    const сollegesListProfession = ref()
    const сollegesListProfesionalitet = ref()

    const createMarksList = (collegelist) => {
        const markers = ref([]);
        collegelist.forEach((college) => {
            markers.value.push({ coordinates: [college.lat, college.lon], description: "<b>"+college.title+"</b>"+"<br>"+college.address+"<br>"+"Номер телефона: "+college.phone+"<br>" });
        });
        return markers.value;
    }
    
    

    const getCollegesFromSpeciality = async (directionId, name) => {
        isPending.value = true;
        // const token = VueCookies.get('token');
        const { error, data } = await useFetch(BASE_URI + "/api/view/establishments/speciality/"+directionId+"?query="+name, {
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            // },
        }).get().json();
            
        if (error.value) {
            console.log(error.value)
            isPending.value = false;
            return error.value;
        } else {
            сollegesList.value = data.value;
            console.log(сollegesList.value)
            isPending.value = false;
            return createMarksList(data.value.establishments);
        }
    
    }

    const getCollegesFromProfession = async (directionId, name) => {
        isPending.value = true;
        // const token = VueCookies.get('token');
        const { error, data } = await useFetch(BASE_URI + "/api/view/establishments/profession/"+directionId+"?query="+name, {
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            // },
        }).get().json();
            
        if (error.value) {
            console.log(error.value)
            isPending.value = false;
            return error.value;
        } else {
            сollegesListProfession.value = data.value;
            console.log(сollegesListProfession.value)
            isPending.value = false;
            return createMarksList(data.value.establishments);
        }
    
    }

    const getCollegesFromProfessionalism = async (directionId, name) => {
        isPending.value = true;
        // const token = VueCookies.get('token');
        const { error, data } = await useFetch(BASE_URI + "/api/view/establishments/professionalism/"+directionId+"?query="+name, {
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            // },
        }).get().json();
            
        if (error.value) {
            console.log(error.value)
            isPending.value = false;
            return error.value;
        } else {
            сollegesListProfesionalitet.value = data.value;
            console.log(сollegesListProfesionalitet.value)
            isPending.value = false;
            return createMarksList(data.value.establishments);
        }
    
    }

    return{
        isPending,
        getCollegesFromSpeciality,
        getCollegesFromProfession,
        getCollegesFromProfessionalism,
        сollegesList,
        сollegesListProfession,
        сollegesListProfesionalitet
    }

})